import React from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import { useParams } from "react-router-dom";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2.8rem",
  padding: "0 2rem",
  color: theme.color.gray,
  fontSize: "1.4rem",
  lineHeight: "2.4rem",
}));

const Title = styled.p(({ theme }) => ({
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  color: "#111",
  padding: "2.8rem 0 1.6rem",
  borderBottom: `1px solid ${theme.color.border_gray}`,
}));

const NewsDetail = () => {
  const params = useParams();
  const { getNewsDetail } = useApiRequest();
  const lang = window.localStorage.getItem("language");

  const { data: newsDetail } = useQuery({
    queryKey: ["newsDetail", params.newsId],
    queryFn: () => getNewsDetail(Number(params.newsId)),
  });

  return (
    <>
      <BackHeader title="새소식" underline />

      <Container>
        <Title>
          {lang === "en" && newsDetail?.title_en
            ? newsDetail?.title_en
            : newsDetail?.title_ko}
        </Title>

        <span>
          {lang === "en" && newsDetail?.content_en
            ? newsDetail?.content_en
            : newsDetail?.content_ko}
        </span>
      </Container>
    </>
  );
};

export default NewsDetail;
